<h2>Noch keine Artikel erfasst</h2>
<p>Fügen Sie Artikel per Schnellerfassung oder Artikelsuche zur Liste hinzu, um mit der Erfassung zu starten.</p>
<div class="buttons">
  <ui-button buttonStyle="text" iconStyle="light" icon="list-check" (click)="tabSelected.emit('quickorder')">
    Schnellerfassung verwenden
  </ui-button>
  <ui-button buttonStyle="text" iconStyle="light" icon="magnifying-glass" (click)="tabSelected.emit('search')">
    Artikelsuche starten
  </ui-button>
</div>
